import SalesOfficersList from './salesOfficersList';
import SalesOfficersEdit from './salesOfficersEdit';
import SalesOfficersCreate from './salesOfficersCreate';
import SalesOfficersShow from './salesOfficersShow';

export default {
    list: SalesOfficersList,
    edit: SalesOfficersEdit,
    show: SalesOfficersShow,
    create: SalesOfficersCreate
}